var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInkscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 120.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6h1.7c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v10c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.6zm7.3 0c1-.1 1.6-.6 1.6-1.4v-9.9c0-1.5-.4-2-1.8-2.2v-.6h.7c1.1 0 2.2-.1 2.2-.1s.3.5.8 1.1l8 9.2.9 1.2v-9.2c0-1 0-1.5-1.8-1.7v-.6h4.2l.1.3s-1.5.4-1.5 2.2v12.2h-.6l-9.4-11c-.3-.3-.6-.7-.8-1.1v10c0 .7-.1 1.2-.1 1.2l2 .1-.1.6-4.3.1v-.4zm16.9 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6h1.7c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v3.9h.4s.4-.2.7-.6l4.3-4.3c.4-.4.4-1-.6-1.1v-.6h4.1l.1.3s-1.2.3-2.8 1.9l-4.2 4.1v.2l5.3 6.1c1 1.1 1.2 1.2 1.9 1.3h.2l-.1.7h-3.2l-.1-.1s-.2-.7-1.7-2.3l-4.1-4.8h-.4v5.2c0 .6-.1 1.1-.1 1.1l2 .2-.1.6-5.3.1v-.5zm14.4-3.3h.7c0 2.7 1.7 3.4 3.2 3.4 1.4 0 2.8-.6 2.8-2.3 0-3.8-6.9-3.8-6.9-8.2 0-2.2 1.6-3.8 4.9-3.8 1.6 0 3.1.4 3.6.4l-.7 3.4H59c.2-1.6-.6-3-2.5-3-1.5 0-2.7.7-2.7 2.3 0 3.9 6.9 3.5 6.9 8.2 0 2.6-2.3 3.9-4.9 3.9-1.9 0-4.2-.7-4.2-2.3 0-.4.1-.7.5-2zm18.7-11c1.6 0 3.6.4 4.8.5l-.7 3.3h-.7c0-2.3-1.9-3-3.7-3-3.4 0-5.6 2.7-5.6 6.3 0 4 2.8 6.6 6.4 6.6 2.8 0 4.4-1.6 4.4-1.6l.3.5s-1.7 2.6-5.5 2.6c-3.9 0-7.7-2.7-7.7-7.4 0-4.5 3.3-7.8 8-7.8zm5.6 14.3c.9-.1 1.3-.5 1.5-1l5.2-13 .9-.2 4.9 12.5c.6 1.5 1 1.6 1.7 1.7l-.1.6h-.9c-.8 0-3.3.1-3.3.1v-.7c.6 0 1.2-.2.9-.9l-1.3-3.5h-5.3l-.3.2-1.5 4 1.9.3-.1.6h-4.1v-.7zm6.7-11.7l-2.4 6.4h4.8l-1.9-5c-.2-.5-.4-1.1-.5-1.4zm8.5 11.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h5.5c2.5 0 5.4.8 5.4 4 0 3.5-3.3 4.7-5.7 4.5v-.6c2.6-.1 3.5-1.7 3.5-3.4 0-2.6-2.1-3.7-4.4-3.7h-.3l-.2.2v11.6c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.5zm12.4 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h9.1c.9 0 1.6-.1 1.6-.1l-.7 3.7h-.8c.1-2.3-.6-2.7-2.4-2.7h-2.9l-.2.2v5.7h4.1l.2-1.3.8-.1v3.9h-1v-1.6h-3.8l-.2.2v4.7c0 .7-.1 1.2-.1 1.2h3.5c1.9 0 2.2-.4 3.3-2.7h.7l-.8 3.6h-6.9c-1.1 0-3.2.1-3.2.1v-.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.994 0 0 .994 .389 -1.445)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.783
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1 8.288l-37.2 38.1c-14.1 14.1 9.1 12.9 17.5 18.2 3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4l-38.5-39.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zm-62.7 10c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.576,
    d: "M55.1 9.188l-37.2 38.1c-14.1 14.1 9.1 12.9 17.5 18.2 3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4l-38.5-39.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.8-12.2-5.3-13.9.5zm-62.7 10c3.3 2.9 8.4-.6 10-4.7-3.2-4.3-15.2.3-10 4.7zm60.9-6.1c-4.2 3.8.7 7.8 4.8 5.1 1.1-.6-.1-4.2-4.8-5.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 7.4L17.9 45.5C3.8 59.6 27 58.4 35.4 63.7c3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4L72.1 7.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zM35 90.8c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 7.4L17.9 45.5C3.8 59.6 27 58.4 35.4 63.7c3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4L72.1 7.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zM35 90.8c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "inkscape-original-wordmark-a",
    d: "M55.2 7.9L18.3 45.6c-13.9 13.9 9 12.8 17.3 18.1 3.8 2.5-12.3 5.7-9 9C29.9 76 46 79 49.3 82.2L46 92.3c3.1 3.3 10.6.2 12 7.7 1 5.5 13.8 2.8 19.5-2 3.6-3-6.2-3-2.9-6.3 8-8.1 15.2-3.7 18.1-11.2 1.6-4-12.2-6.9-8.5-9.5 8.8-6.2 40.9-9.3 26.1-24.1L72 7.9c-4.7-4.5-12.5-4.5-16.8 0zm-8.9 57.8c.8 0 27.5 3.6 17.2 6.3-3.9 1.1-21.9-6.3-17.2-6.3zm51.1 14.8c0 1.9 14.6 2.9 13.8-.4-1.2-5.7-12.2-5.3-13.8.4zm-62.1 10c3.3 2.9 8.3-.6 9.9-4.6-3.2-4.3-15.1.2-9.9 4.6zm60.3-6c-4.1 3.8.7 7.7 4.7 5.1 1.1-.8 0-4.2-4.7-5.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "inkscape-original-wordmark-b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inkscape-original-wordmark-a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.991 0 0 .991 .605 .604)",
    clipPath: "url(#inkscape-original-wordmark-b)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-c",
    gradientUnits: "userSpaceOnUse",
    x1: 91.626,
    y1: -56.37,
    x2: 71.669,
    y2: -74.414,
    gradientTransform: "matrix(.985 0 0 -.985 6.128 -23.064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C0CDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07092D",
    stopOpacity: 0.288
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-c)",
    d: "M55.2 7.9L18.3 45.6c-13.9 13.9 9 12.8 17.3 18.1 3.8 2.5-12.3 5.7-9 9C29.9 76 46 79 49.3 82.2L46 92.3c3.1 3.3 10.6.2 12 7.7 1 5.5 13.8 2.8 19.5-2 3.6-3-6.2-3-2.9-6.3 8-8.1 15.2-3.7 18.1-11.2 1.6-4-12.2-6.9-8.5-9.5 8.8-6.2 40.9-9.3 26.1-24.1L72 7.9c-4.7-4.5-12.5-4.5-16.8 0zm-8.9 57.8c.8 0 27.5 3.6 17.2 6.3-3.9 1.1-21.9-6.3-17.2-6.3zm51.1 14.8c0 1.9 14.6 2.9 13.8-.4-1.2-5.7-12.2-5.3-13.8.4zm-62.1 10c3.3 2.9 8.3-.6 9.9-4.6-3.2-4.3-15.1.2-9.9 4.6zm60.3-6c-4.1 3.8.7 7.7 4.7 5.1 1.1-.8 0-4.2-4.7-5.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-d",
    gradientUnits: "userSpaceOnUse",
    x1: 38.411,
    y1: -47.051,
    x2: 60.967,
    y2: -69.606,
    gradientTransform: "matrix(1.003 0 0 -1.003 -.413 -21.676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    fill: "url(#inkscape-original-wordmark-d)",
    d: "M21.2 47.6c-10.1 10 7.6 7.2 21.3 12.6l28.2-49.6c-4.3-4.4-9.7-4-13.7 0l-35.8 37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-e",
    gradientUnits: "userSpaceOnUse",
    x1: 50.814,
    y1: -44.11,
    x2: 77.881,
    y2: -71.177,
    gradientTransform: "matrix(.994 0 0 -.994 2.709 -22.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-e)",
    d: "M69.9 10.1l14.7 15c1.4 1.4 1.4 4.2.5 5l-7.3-6-1.4 8.8-6-3.2-9.8 6.2-3.2-13.1L52 34.1 38.9 34c-2.5 0-2.2-2.6.5-5.2 5.1-5.7 15.2-15.3 18.3-18.7 3.2-3.3 8.9-3.2 12.2 0z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-f",
    cx: 55.343,
    cy: -368.06,
    r: 27.608,
    gradientTransform: "matrix(.827 0 0 -.553 1.123 -104.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.217,
    fill: "url(#inkscape-original-wordmark-f)",
    d: "M49.7 80.9s1.6 2.4 1.4 3.6c-.3 2.3-5.2 3.4-4.1 5.4 1.1 2 4.9.9 8.1 2.9 3.2 2.1 2.3 6.3 4.7 7.3 4.5 2.1 16.4-3.6 15.8-3.4-.6.1-11.7 2.4-14.2.4-2.9-2.3-3.7-3.9-5.8-5.3-2-1.3-4.8-1.8-5.4-2.9-.6-1.1 1.3-2.4 1.4-4.4.1-1.2-1.9-3.6-1.9-3.6z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.276
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-g",
    cx: 148.42,
    cy: -316.346,
    r: 27.608,
    gradientTransform: "matrix(1.055 0 0 -.706 -97.55 -123.665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-g)",
    d: "M49.7 80.9s1.6 2.4 1.4 3.6c-.3 2.3-5.2 3.4-4.1 5.4 1.1 2 4.9.9 8.1 2.9 3.2 2.1 2.3 6.3 4.7 7.3 4.5 2.1 16.4-3.6 15.8-3.4-19.8.1-16.1-5-23.7-8.4-1.1-.5-.5-1.8-.3-3.8.1-1.2-1.9-3.6-1.9-3.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-h",
    cx: -66.136,
    cy: -663.625,
    r: 30.901,
    gradientTransform: "matrix(.526 0 0 -.223 130.969 -83.733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.453,
    fill: "url(#inkscape-original-wordmark-h)",
    d: "M83.2 70.5c17.7-6.5 23.4-7.4 29.3-13.3-6.7 5.8-21.1 8.8-32.7 13.9l3.4-.6z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.512
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-i",
    cx: -59.555,
    cy: -676.361,
    r: 30.901,
    gradientTransform: "matrix(.526 0 0 -.223 130.969 -84.659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-i)",
    d: "M83.2 69.7c29.2-10.3 24.3-10.3 29.3-13.3-9.3 3.6-26.6 3.9-32.7 13.9l3.4-.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-j",
    gradientUnits: "userSpaceOnUse",
    x1: -48.211,
    y1: -329.198,
    x2: -48.099,
    y2: -334.893,
    gradientTransform: "matrix(.526 0 0 -.526 130.306 -97.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#inkscape-original-wordmark-j)",
    d: "M108.8 77.9c0 .6-1.7 1.2-3.8 1.2-2.1 0-3.8-.5-3.8-1.2 0-.6 1.7-1.2 3.8-1.2 2.1.1 3.8.6 3.8 1.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-k",
    gradientUnits: "userSpaceOnUse",
    x1: 100.816,
    y1: -189.809,
    x2: 100.816,
    y2: -193.824,
    gradientTransform: "matrix(.709 0 0 -1.134 33.501 -139.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-k)",
    d: "M110.1 79.3c0 1.4-2.3 2.5-5.1 2.5s-5.1-1.1-5.1-2.5 2.3-2.5 5.1-2.5 5.1 1.1 5.1 2.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-l",
    cx: -49.825,
    cy: -1837.368,
    r: 12.716,
    gradientTransform: "matrix(.526 0 0 -.078 130.969 -61.714)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-l)",
    d: "M98 80.7c1.8 1.7 11.8 2.5 13.5-.5-3.2 2.3-10.4 1.5-13.5.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-m",
    gradientUnits: "userSpaceOnUse",
    x1: -930.712,
    y1: -38.355,
    x2: -930.6,
    y2: -44.05,
    gradientTransform: "matrix(.203 -.103 -.238 -.469 275.813 -28.596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#inkscape-original-wordmark-m)",
    d: "M98 86.2c.4.7.1 1.6-.5 1.9-.7.3-1.5 0-1.9-.7-.4-.7-.1-1.6.5-1.9s1.6 0 1.9.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-n",
    gradientUnits: "userSpaceOnUse",
    x1: -554.563,
    y1: -54.844,
    x2: -554.563,
    y2: -58.859,
    gradientTransform: "matrix(.273 -.139 -.513 -1.011 218.865 -48.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-n)",
    d: "M98.8 86.6c.6 1.1.2 2.4-.8 2.9s-2.2 0-2.7-1.1c-.6-1.2-.3-2.4.7-2.9s2.2 0 2.8 1.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-o",
    cx: -932.326,
    cy: 131.174,
    r: 12.716,
    gradientTransform: "matrix(.203 -.103 -.035 -.069 292.115 2.923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-o)",
    d: "M95.5 89.6c1.4 1.1 6.9 1.3 4.8-2 .6 2.6-3.1 2.3-4.8 2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-p",
    cx: -175.404,
    cy: -702.254,
    r: 20.526,
    gradientTransform: "matrix(.526 0 0 -.214 130.969 -74.982)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-p)",
    d: "M28.3 72.5c0-.3 18.6 5.7 21.7 8.8-2.6-2.6-15.8-8.4-17.9-8.5-1.9 0-3.6-.1-3.8-.3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.879 -.193 .234 .696 -20.21 36.726)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-q",
    gradientUnits: "userSpaceOnUse",
    x1: -46.833,
    y1: -423.586,
    x2: -46.72,
    y2: -429.281,
    gradientTransform: "matrix(.463 .102 .123 -.366 118.863 -68.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.286,
    fill: "url(#inkscape-original-wordmark-q)",
    d: "M48.9 83.3c0 .6-1.7 1.2-3.8 1.2-2.1 0-3.8-.5-3.8-1.2 0-.6 1.7-1.2 3.8-1.2s3.8.6 3.8 1.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-r",
    gradientUnits: "userSpaceOnUse",
    x1: 107.319,
    y1: -242.262,
    x2: 107.319,
    y2: -246.277,
    gradientTransform: "matrix(.623 .219 .166 -.789 18.372 -133.516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-r)",
    d: "M50.2 84.7c0 1.4-2.3 2.5-5.1 2.5S40 86.1 40 84.7s2.3-2.5 5.1-2.5 5.1 1.1 5.1 2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.616
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-s",
    cx: -108.767,
    cy: -316.224,
    r: 9.445,
    gradientTransform: "matrix(.624 -.173 -.065 -.233 86.317 -1.652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-s)",
    d: "M34.2 88.3s1 2.7 3.8 2.8c2.8.1 6-3.3 6.2-4.6-.5 1.1-3.1 4.3-6.6 4.3-1.9 0-3.4-2.5-3.4-2.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-t",
    cx: 192.543,
    cy: 21.454,
    r: 49.468,
    gradientTransform: "matrix(1.712 0 0 -1.685 -261.607 52.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#inkscape-original-wordmark-t)",
    strokeWidth: 0.488,
    d: "M63.5 5.4c-2.8 0-5.5 1-7.5 3l-37.2 38c-3.4 3.4-4.2 5.6-4 6.9.1.6.4 1.2 1.1 1.7.7.6 1.7 1.1 2.8 1.6 2.4 1 5.6 1.8 8.8 2.7s6.3 1.8 8.6 3.3c.4.2.7.5.9.9.2.4.3 1 .2 1.4-.2.9-.8 1.4-1.3 1.8-1.1.9-2.7 1.6-4.3 2.4s-3.2 1.6-4 2.2c-.4.3-.5.6-.5.6s-.1-.2.1-.1c.5.5 2.1 1.4 4 2.2s4.4 1.6 6.9 2.4c2.4.8 4.9 1.6 7 2.4 2.1.8 3.8 1.6 4.9 2.7.6.6 1 1.3 1 2 .1.7-.1 1.4-.4 2-.6 1.2-1.5 2-2.3 2.9-.8.9-1.6 1.7-1.8 2.2-.1.3-.2.5-.1.6s0 .2.3.5c1.1 1.1 3.4 1.3 6.1 1.9 1.3.3 2.7.8 3.9 1.8 1.2 1 2.1 2.6 2.5 4.7.2.9.6 1.3 1.8 1.7 1.1.4 2.9.4 4.8.1 3.8-.6 8.4-2.4 11-4.6.2-.1.1-.1.2-.2-.2-.1-.6-.4-1.3-.7-.8-.4-1.8-.8-2.5-1.7-.4-.5-.6-1.2-.5-1.9.1-.7.5-1.3 1-1.8 4.3-4.3 8.5-5.4 11.7-6.2 1.6-.4 2.9-.8 3.9-1.4 1-.6 1.8-1.5 2.5-3.2.1-.2.1-.2 0-.5s-.4-.6-.8-.9c-.8-.7-2.3-1.5-3.7-2.3-1.4-.8-2.8-1.5-3.7-2.4-.5-.5-1-1-1.1-1.9-.1-.9.5-1.7 1.2-2.1 2.5-1.7 6.2-3.1 10.3-4.5 4.1-1.4 8.4-2.9 12-4.5 3.6-1.7 6.2-3.6 7-5.5.4-1 .5-1.9.1-3.2-.4-1.3-1.4-2.8-3.2-4.6L71.2 8.4c-2.1-2-5-3-7.7-3zm41.4 72.2c-2.4.1-4.6 1.2-5.5 2.9.3.1.5.2.9.3 1.2.3 3 .5 4.7.5 1.7 0 3.4-.1 4.5-.4.5-.1.7-.3.8-.3-.2-1-.8-1.7-1.7-2.2-1-.6-2.3-.9-3.7-.8zm-63.6 8.1c-1.9-.1-4.3.6-5.4 1.6-.6.5-.8.9-.8 1.2 0 .3.1.7.8 1.3 1.2 1.1 2.6.9 4.2.1 1.3-.7 2.5-2.1 3.3-3.5-.6-.3-1.2-.6-2.1-.7zm55 .6c-.4.5-.6 1-.6 1.3 0 .5.1.8.5 1.2.7.6 2.1.9 3.6.1 0-.2-.1-.4-.3-.8-.5-.6-1.6-1.3-3.2-1.8z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.325
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-u",
    gradientUnits: "userSpaceOnUse",
    x1: -216.308,
    y1: -354.586,
    x2: -163.979,
    y2: -368.423,
    gradientTransform: "matrix(.485 0 0 -.485 149.184 -95.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-u)",
    d: "M43.1 65c-2.2.7-9.5 3.4-8.5 5.5 1 2 17.9 2.8 20.5 8.8 1.1 2.6-2.6 4.6-1.7 7.3.7 2.1 6.3 7.3 9.9 9.7 2.8 1.9 6.5-1.6 5-4.4-2.4-4.6 8.1-10.2 12.9-12.8 2.8-1.5-5.7-8.8-5.7-8.8L43.1 65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-v",
    gradientUnits: "userSpaceOnUse",
    x1: 15.146,
    y1: -105.339,
    x2: 11.904,
    y2: -112.767,
    gradientTransform: "matrix(.88 0 0 -.88 42.035 -27.857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EEEEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-v)",
    d: "M43.9 67c2 1.5 6 .6 8.4 1.7 5.7 2.6 12.8 5.5 11.5.4l-1.5 1.2V68l-3.4.8s-2.6-2.1-3.8-2.8c-.3-.1-1.5 1.2-1.5 1.2l-.2-1.4c-1.7-.2-3.3-.3-4.8-.2-3.6-.1-6 .5-4.7 1.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.478
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "inkscape-original-wordmark-w",
    cx: 21.139,
    cy: -251.475,
    r: 20.27,
    gradientTransform: "matrix(.656 0 0 -.834 66.991 -125.902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-w)",
    d: "M81.5 71.7c-.8 2.9 9.5 6.7 8.8 8.7-1.7 4.3-11 1.4-18.1 10.5-1 1.3 1.4 5.9 1.1 5.4s-2.8-4.4-2.2-6.3c2-5.9 21.6-8.1 18-11-2.1-1.6-9.5-6.1-7.6-7.3z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fill: "#fff",
    d: "M104.7 77.6c0 .3-.5.5-1.1.5-.6 0-1.1-.2-1.1-.5s.5-.5 1.1-.5c.6 0 1.1.2 1.1.5zM97.2 86.2c0 .3-.3.5-.7.5-.4 0-.7-.2-.7-.5s.3-.5.7-.5c.3 0 .7.3.7.5zM40.1 85.8c0 .3-.6.5-1.3.5-.7 0-1.3-.2-1.3-.5s.6-.5 1.3-.5c.7 0 1.3.2 1.3.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-x",
    gradientUnits: "userSpaceOnUse",
    x1: -233.056,
    y1: -336.04,
    x2: -224.899,
    y2: -342.521,
    gradientTransform: "matrix(.49 0 0 -.49 147.66 -96.827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.251,
    fill: "url(#inkscape-original-wordmark-x)",
    d: "M39.3 65.2c-6.5 4-16.5 5.4-5.5 8.1-1.3-2.9 2.9-2.6 5.5-8.1z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.363
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inkscape-original-wordmark-y",
    gradientUnits: "userSpaceOnUse",
    x1: -125.584,
    y1: -365.933,
    x2: -150.045,
    y2: -300.07,
    gradientTransform: "matrix(.485 0 0 -.485 149.184 -95.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729FCF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inkscape-original-wordmark-y)",
    d: "M62.3 101.6s10-.9 12.3-3.8c1.3-1.7-5.4-3.6-3.9-5.3 5.4-6.2 10-5.9 16.3-8.5s4-3.9 1.9-5c-3.5-2-11.3-4-8.7-8.7 2.6-4.7 25.3-11.1 25.3-11.1 6.9-2.3 6-6.6 2.6-10.1L87.8 28.9s1 19.1-3.1 27.3c-5.1 10.1-32 21.4-20.7 22.7 4 .4 5.9 1.8 7.5 4.8 3.3 6.3-9.2 17.9-9.2 17.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkscape);
export default __webpack_public_path__ + "static/media/inkscape.cae7fa0237585cf750dfa40f3552ca6f.svg";
export { ForwardRef as ReactComponent };